import { render } from "./index.vue?vue&type=template&id=fbc8f250&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=fbc8f250&lang=scss&scoped=true"

import exportComponent from "/Users/user/workspace/okshop-diner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc8f250"]])

export default __exports__